<form [formGroup]="physicalCapabilityForm">
    <div class="step-container">
      <ng-template #labelTen>{{ getTranslation('physicalFitness.title') }}</ng-template>
      <div class="step-title">
        {{ isEditable ? getTranslation('physicalFitness.title') : getTranslation('physicalFitness.blockedForEdit') }}
        <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
      </div>
  
      <div *ngIf="isJsonShow">
        {{physicalCapabilityForm.value | json}}
      </div>
 


      <div class="row gx-2">
        <!-- Climb 3 flights of stairs -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0" [ngClass]="{'text-danger': physicalCapabilityForm.controls['CanClimbStairs'].invalid && submitted}">{{ getTranslation('physicalFitness.canClimbStairs') }}<span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="CanClimbStairs" [value]='true'class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="CanClimbStairs" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && physicalCapabilityForm.controls['CanClimbStairs'].invalid" class="text-danger-val">
                {{ getTranslation('validation.requiredField') }}
              </div>
            </div>
          </div>
          <div *ngIf="physicalCapabilityForm.get('CanClimbStairs')?.value === false" class="mt-2">
            <label for="ClimbStairsReason" class="form-label"> {{ getTranslation('physicalFitness.why') }}<span class="text-danger">*</span></label>
            <textarea class="form-control" id="ClimbStairsReason" formControlName="ClimbStairsReason" maxlength="500" placeholder="{{ getTranslation('placeholder.enterReason') }}"></textarea>
            <div *ngIf="submitted && physicalCapabilityForm.controls['ClimbStairsReason'].invalid" class="text-danger">
              {{ getTranslation('validation.requiredField') }}
            </div>
          </div>
        </div>
  



     <!-- Walk 1.5 km or 1 mile -->
<div class="form-group col-12 mb-3">
  <div class="row">
    <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': physicalCapabilityForm.controls['CanWalkDistance'].invalid && submitted}">{{ getTranslation('physicalFitness.canWalkDistance') }}<span class="text-danger">*</span></label>
    <div class="col-md-4 d-flex align-items-center">
      <label class="mr-5"><input type="radio" class="form-check-input" formControlName="CanWalkDistance" [value]='true'class="me-2"> {{ getTranslation('common.yes') }}</label>
      <label><input type="radio" class="form-check-input" formControlName="CanWalkDistance"  [value]="false"> {{ getTranslation('common.no') }}</label>
      <div *ngIf="submitted && physicalCapabilityForm.controls['CanWalkDistance'].invalid" class="text-danger-val">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>
  </div>
  <div *ngIf="physicalCapabilityForm.get('CanWalkDistance')?.value === false" class="mt-2">
    <label for="WalkDistanceReason" class="form-label"> {{ getTranslation('physicalFitness.why') }}<span class="text-danger">*</span></label>
    <textarea class="form-control" id="WalkDistanceReason" formControlName="WalkDistanceReason" maxlength="500"  placeholder="{{ getTranslation('placeholder.enterReason') }}"></textarea>
    <div *ngIf="submitted && physicalCapabilityForm.controls['WalkDistanceReason'].invalid" class="text-danger">
      {{ getTranslation('validation.requiredField') }}
    </div>
  </div>
</div>





<!-- Lift 4 kg (10 lbs) -->
<div class="form-group col-12 mb-3">
  <div class="row">
    <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': physicalCapabilityForm.controls['CanLiftWeight'].invalid && submitted}">{{ getTranslation('physicalFitness.canLiftWeight') }}<span class="text-danger">*</span></label>
    <div class="col-md-4 d-flex align-items-center">
      <label class="mr-5"><input type="radio" class="form-check-input" formControlName="CanLiftWeight" [value]='true' class="me-2"> {{ getTranslation('common.yes') }}</label>
      <label><input type="radio" class="form-check-input" formControlName="CanLiftWeight"  [value]="false"> {{ getTranslation('common.no') }}</label>
      <div *ngIf="submitted && physicalCapabilityForm.controls['CanLiftWeight'].invalid" class="text-danger-val">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>
  </div>
  <div *ngIf="physicalCapabilityForm.get('CanLiftWeight')?.value === false" class="mt-2">
    <label for="LiftWeightReason" class="form-label"> {{ getTranslation('physicalFitness.why') }}<span class="text-danger">*</span></label>
    <textarea class="form-control" id="LiftWeightReason" formControlName="LiftWeightReason" maxlength="500"  placeholder="{{ getTranslation('placeholder.enterReason') }}"></textarea>
    <div *ngIf="submitted && physicalCapabilityForm.controls['LiftWeightReason'].invalid" class="text-danger">
      {{ getTranslation('validation.requiredField') }}
    </div>
  </div>
</div>







<!-- Stand for 30 minutes -->
<div class="form-group col-12 mb-3">
  <div class="row">
    <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': physicalCapabilityForm.controls['CanStandDuration'].invalid && submitted}">{{ getTranslation('physicalFitness.canStandDuration') }}<span class="text-danger">*</span></label>
    <div class="col-md-4 d-flex align-items-center">
      <label class="mr-5"><input type="radio" class="form-check-input" formControlName="CanStandDuration" [value]='true' class="me-2"> {{ getTranslation('common.yes') }}</label>
      <label><input type="radio" class="form-check-input" formControlName="CanStandDuration"  [value]="false"> {{ getTranslation('common.no') }}</label>
      <div *ngIf="submitted && physicalCapabilityForm.controls['CanStandDuration'].invalid" class="text-danger-val">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>
  </div>
  <div *ngIf="physicalCapabilityForm.get('CanStandDuration')?.value === false" class="mt-2">
    <label for="StandDurationReason" class="form-label"> {{ getTranslation('physicalFitness.why') }}<span class="text-danger">*</span></label>
    <textarea class="form-control" id="StandDurationReason" formControlName="StandDurationReason" maxlength="500"  placeholder="{{ getTranslation('placeholder.enterReason') }}"></textarea>
    <div *ngIf="submitted && physicalCapabilityForm.controls['StandDurationReason'].invalid" class="text-danger">
      {{ getTranslation('validation.requiredField') }}
    </div>
  </div>
</div>





  <!-- Sit for 30 minutes -->
<div class="form-group col-12 mb-3">
  <div class="row">
    <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': physicalCapabilityForm.controls['CanSitDuration'].invalid && submitted}">{{ getTranslation('physicalFitness.canSitDuration') }}<span class="text-danger">*</span></label>
    <div class="col-md-4 d-flex align-items-center">
      <label class="mr-5"><input type="radio" class="form-check-input" formControlName="CanSitDuration" [value]='true' class="me-2" > {{ getTranslation('common.yes') }}</label>
      <label><input type="radio" class="form-check-input" formControlName="CanSitDuration"  [value]="false"> {{ getTranslation('common.no') }}</label>
      <div *ngIf="submitted && physicalCapabilityForm.controls['CanSitDuration'].invalid" class="text-danger-val">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>
  </div>
  <div *ngIf="physicalCapabilityForm.get('CanSitDuration')?.value === false" class="mt-2">
    <label for="SitDurationReason" class="form-label"> {{ getTranslation('physicalFitness.why') }}<span class="text-danger">*</span></label>
    <textarea class="form-control" id="SitDurationReason" formControlName="SitDurationReason" maxlength="500"  placeholder="{{ getTranslation('placeholder.enterReason') }}"></textarea>
    <div *ngIf="submitted && physicalCapabilityForm.controls['SitDurationReason'].invalid" class="text-danger">
      {{ getTranslation('validation.requiredField') }}
    </div>
  </div>
</div>




<!-- Bend over -->
<div class="form-group col-12 mb-3">
  <div class="row">
    <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': physicalCapabilityForm.controls['CanBendOver'].invalid && submitted}">{{ getTranslation('physicalFitness.canBendOver') }}<span class="text-danger">*</span></label>
    <div class="col-md-4 d-flex align-items-center">
      <label class="mr-5"><input type="radio" class="form-check-input" formControlName="CanBendOver" [value]='true' class="me-2"> {{ getTranslation('common.yes') }}</label>
      <label><input type="radio" class="form-check-input" formControlName="CanBendOver"  [value]="false"> {{ getTranslation('common.no') }}</label>
      <div *ngIf="submitted && physicalCapabilityForm.controls['CanBendOver'].invalid" class="text-danger-val">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>
  </div>
  <div *ngIf="physicalCapabilityForm.get('CanBendOver')?.value === false" class="mt-2">
    <label for="BendOverReason" class="form-label">{{ getTranslation('physicalFitness.ifNoWhy') }}<span class="text-danger">*</span></label>
    <textarea class="form-control" id="BendOverReason" formControlName="BendOverReason" maxlength="500"  placeholder="{{ getTranslation('placeholder.enterReason') }}"></textarea>
    <div *ngIf="submitted && physicalCapabilityForm.controls['BendOverReason'].invalid" class="text-danger">
      {{ getTranslation('validation.requiredField') }}
    </div>
  </div>
</div>









<div class="form-group col-12 mb-3">
  <div class="row">
    <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': physicalCapabilityForm.controls['DoExcercise'].invalid && submitted}">{{ getTranslation('physicalFitness.doExerciseRegularly') }}<span class="text-danger">*</span></label>
    <div class="col-md-4 d-flex align-items-center">
      <label class="mr-5"><input type="radio" class="form-check-input" formControlName="DoExcercise" [value]='true' class="me-2" > {{ getTranslation('common.yes') }}</label>
      <label><input type="radio" class="form-check-input" formControlName="DoExcercise" [value]="false"> {{ getTranslation('common.no') }}</label>
      <div *ngIf="submitted && physicalCapabilityForm.controls['DoExcercise'].invalid" class="text-danger-val">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>
  </div>

  <!-- Exercise Type and Frequency fields will appear if "Yes" is selected -->
  <div *ngIf="physicalCapabilityForm.get('DoExcercise')?.value === true" class="mt-2">
    <div class="form-group">
      <label for="ExerciseType" class="form-label">{{ getTranslation('physicalFitness.exerciseType') }}<span class="text-danger">*</span></label>
      <input type="text" class="form-control" id="ExerciseType" formControlName="ExerciseType" maxlength="500" placeholder="{{ getTranslation('placeholder.enterExerciseType') }}">
      <div *ngIf="submitted && physicalCapabilityForm.controls['ExerciseType'].invalid" class="text-danger">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>

    <div class="form-group mt-3">
      <label for="ExerciseFrequency" class="form-label">{{ getTranslation('physicalFitness.exerciseFrequency') }}<span class="text-danger">*</span></label>
      <input type="text" class="form-control" id="ExerciseFrequency" formControlName="ExerciseFrequency" maxlength="500" placeholder="{{ getTranslation('placeholder.enterExerciseFrequency') }}">
      <div *ngIf="submitted && physicalCapabilityForm.controls['ExerciseFrequency'].invalid" class="text-danger">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>
  </div>
</div>














 <!-- Overall Health -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-3 mb-0"  [ngClass]="{'text-danger': physicalCapabilityForm.controls['OverallHealth'].invalid && submitted}">{{ getTranslation('physicalFitness.overallHealth') }}<span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center ml-2">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="OverallHealth" value="Poor"> {{ getTranslation('physicalFitness.healthPoor') }}</label>
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="OverallHealth" value="Good"> {{ getTranslation('physicalFitness.healthGood') }}</label>
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="OverallHealth" value="Excellent"> {{ getTranslation('physicalFitness.healthExcellent') }}</label>
             
            </div>
          </div>
          <div *ngIf="submitted && physicalCapabilityForm.controls['OverallHealth'].invalid" class="text-danger">
            {{ getTranslation('validation.requiredField') }}
          </div>
        </div>







       <!-- Overall Health -->
<!-- <div class="form-group col-12 mb-3">
  <label class="form-label">How is your overall health?</label>
  <div class="d-flex">
    <label class="me-4"><input type="radio" formControlName="OverallHealth" value="Poor"> Poor</label>
    <label class="me-4"><input type="radio" formControlName="OverallHealth" value="Good"> Good</label>
    <label><input type="radio" formControlName="OverallHealth" value="Excellent"> Excellent</label>
  </div>
  <div *ngIf="submitted && physicalCapabilityForm.controls['OverallHealth'].invalid" class="text-danger">
    Please select an option for overall health.
  </div>
</div> -->











<!-- Health Comments -->
<div class="form-group col-12 mb-3">
  <label for="HealthComments" class="form-label">{{ getTranslation('physicalFitness.healthComments') }}</label>
  <textarea class="form-control" id="HealthComments" formControlName="HealthComments"  maxlength="500"  placeholder="{{ getTranslation('placeholder.enterComments') }}"></textarea>

  <div *ngIf="submitted && physicalCapabilityForm.controls['HealthComments'].invalid" class="text-danger">
    {{ getTranslation('validation.requiredField') }}
  </div>

</div>

<!-- For Female Students: Pregnancy -->
<div class="form-group col-12 mb-3" *ngIf="genderCode == 'F' ">
  <div class="row">
    <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': physicalCapabilityForm.controls['IsPregnant'].invalid && submitted}">{{ getTranslation('physicalFitness.forFemalePregnancy') }}</label>
    <div class="col-md-4 d-flex align-items-center">
      <label class="mr-5"><input type="radio" formControlName="IsPregnant" [value]='true' class="me-2"> {{ getTranslation('common.yes') }}</label>
      <label><input type="radio" formControlName="IsPregnant"  [value]="false"> {{ getTranslation('common.no') }}</label>
      <div *ngIf="submitted && physicalCapabilityForm.controls['IsPregnant'].invalid" class="text-danger-val">
        {{ getTranslation('validation.requiredField') }}
      </div>
    </div>
  </div>
  <div *ngIf="physicalCapabilityForm.get('IsPregnant')?.value === true" class="mt-2">
    <label for="PregnancyDueDate" class="form-label">{{ getTranslation('physicalFitness.pregnancyDueDate') }}</label>
    <app-custom-date-picker 
      formControlName="PregnancyDueDate" 
      placeholder="{{ getTranslation('placeholder.enterDueDate') }}">
    </app-custom-date-picker>
    <div *ngIf="submitted && physicalCapabilityForm.controls['PregnancyDueDate'].invalid" class="text-danger">
      {{ getTranslation('validation.requiredField') }}
    </div>
  </div>
</div>
</div>
  
      
    </div>
 <!-- Buttons start -->
 <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
  <button type="button" class="btn savedraftbtn" 
          *ngIf="physicalCapabilityForm.get('SaveMode')?.value !== SaveMode.SAVE"
          (click)="onSubmit(SaveMode.DRAFT)">
    <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
  </button>
  <button type="button" class="btn prevbtn" (click)="goToBack()">
    <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
  </button>
  <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
    <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
  </button>
</div>
 <!-- Buttons ends -->
  </form>
  